import React from 'react';
import { useNavigate } from 'react-router-dom';
import './App.css';

const App = () => {
  const navigate = useNavigate();

  const handleGame1Click = () => {
    navigate('/game1');
  };

  const handleGame2Click = () => {
    navigate('/game2'); // 更新這裡以導航到 Game2
  };

  return (
    <div className="app-container">
      <button className="game-button" onClick={handleGame1Click}>
        遊戲一
      </button>
      <button className="game-button" onClick={handleGame2Click}>
        遊戲二
      </button>
    </div>
  );
};

export default App;